const actions = {
  SET_STATE: 'customers/SET_STATE',
  BLOCK_CUSTOMER: 'customers/BLOCK_CUSTOMER',
  UNBLOCK_CUSTOMER: 'customers/UNBLOCK_CUSTOMER',
}

export default actions
